/**
 * Pubsub-subscribe-form.js
 * Subscribe to message for
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */
(function(){
    /**
     * Listen to Successfully submitted form
     */
    $.subscribe('form.submitted.success',function(){
        toastr.success('Update successful')
    });

    /**
     * Listen to submitted form that failed
     */
    $.subscribe('form.submitted.error',function(){
        toastr.error('Update failed!')
    });

    /**
     * Listen to submitted form that failed
     */
    $.subscribe('form.submitted.invalid',function(){
        toastr.warning('Update invalid.')
    });

})();
